var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRemove = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 8,
  height: 9,
  viewBox: "0 0 8 9",
  fill: "#C4C4C4",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 1.65174,
  height: 10.0656,
  rx: 0.825868,
  transform: "matrix(-0.7392 -0.673485 -0.673485 0.7392 8 1.11243)"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  y: 1.11243,
  width: 1.65174,
  height: 10.0656,
  rx: 0.825868,
  transform: "rotate(-42.3366 0 1.11243)"
})));
export default SvgRemove;